import React from 'react'
import type { GatsbyBrowser } from 'gatsby'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { Toaster } from 'react-hot-toast'
import './src/styles/globals.css'

function isExtensionRuntimeNoise(message?: string, source?: string, stack?: string) {
  const haystack = `${message ?? ''} ${source ?? ''} ${stack ?? ''}`
  return haystack.includes('chrome-extension://') || haystack.includes('Failed to connect to MetaMask')
}

if (typeof window !== 'undefined') {
  window.addEventListener('error', (event) => {
    if (isExtensionRuntimeNoise(event.message, event.filename, event.error?.stack)) {
      event.preventDefault()
      event.stopImmediatePropagation()
    }
  }, true)

  window.addEventListener('unhandledrejection', (event) => {
    const reason = event.reason
    const message = reason instanceof Error ? reason.message : String(reason ?? '')
    const stack = reason instanceof Error ? reason.stack : undefined

    if (isExtensionRuntimeNoise(message, undefined, stack)) {
      event.preventDefault()
      event.stopImmediatePropagation()
    }
  }, true)
}

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 1000 * 60 * 5,
      retry: 1,
      refetchOnWindowFocus: false,
    },
  },
})

export const wrapRootElement: GatsbyBrowser['wrapRootElement'] = ({ element }) => (
  <QueryClientProvider client={queryClient}>
    {element}
    <Toaster
      position="top-right"
      gutter={8}
      toastOptions={{
        duration: 4000,
        style: {
          background: '#1E293B',
          color: '#F1F5F9',
          border: '1px solid #334155',
          borderRadius: '0.5rem',
          fontSize: '0.875rem',
          padding: '10px 14px',
        },
        success: {
          iconTheme: { primary: '#10B981', secondary: '#ECFDF5' },
        },
        error: {
          iconTheme: { primary: '#EF4444', secondary: '#FFF1F2' },
        },
      }}
    />
  </QueryClientProvider>
)
